/*
 * web通用host
 * @Author: zhangxb
 * @since: 2021-06-04 16:36:51
 *
 * ======= Usage =======
 * 1. import host, { BASE_URL, PREFIX } from '@yld/tool-host';
 * ======= Done!! ======
 *
 * host 内容
 * {
 *    // 当前环境变量
 *    ENV: <string> development || prod,
 *    // 是否本地开发环境
 *    isLocal: <Boolean> true,
 *    // 是否正式环境（代码是否压缩）
 *    isRelease: <Boolean> true,
 *    // 当前环境标识 dev | qa | ''
 *    PREFIX: <string> 'qa',
 *    // 域名 yunlianda 
 *    DOMAIN: <string> 'yunlianda',
 *    // 基础URL
 *    BASE_URL: <object> {
 *      // 通用api解析标志
 *      API_ORIGIN: '/api',
 *      // 通用数据api
 *      API_COMMON: 'http://yunlianda.com/api/common',
 *      // 网关地址
 *      WG: 'https://gateway.yunlianda.com',
 *      // SSO地址
 *      YLD_PASSPORT: 'http://yunlianda.com/login',
 *      // 主页地址
 *      HOME: 'http://yunlianda.com',
 *    }
 * }
 */

// 支持的环境标识列表
const ENV_LIST = [
  'dev',
  'qa'
];


// 根据当前url地址解析当前的环境标识
function getPrefixByLocation() {
  if (!window || !window.location) {
      throw new Error('无法获取window.location');
  }
  const locationHost = window.location.hostname.split('-');
  const prefix = locationHost[0];
  return ENV_LIST.indexOf(prefix) > -1 ? prefix : '';
}

// 支持host列表
const HOST_LIST = [
  /geekyum\./
];

// 根据链接地址解析geekyum.com
function getHostByLocation() {
  if (!window || !window.location) {
    throw new Error('无法获取window.location');
  }
  const hostName = window.location.hostname;  
  let host = '';
  const hostSplit = hostName.split('.')
  if(hostSplit && hostSplit.length > 1){
    if(hostName.includes('.com.cn')){
      host = hostSplit.slice(-3).join('.');
    } else {
      host = hostSplit.slice(-2).join('.');
    }
  }
  if (!host) {
    throw new Error('无法获取host');
  }
  return host;
}

const NODE_ENV = process.env.NODE_ENV || 'development';
const params = {
  // 解析当前环境变量
  ENV: NODE_ENV,
  // 是否本地环境
  isLocal: process.env.IS_LOCAL === void 0 ? NODE_ENV !== 'production' : process.env.IS_LOCAL,
  // 解析当前环境主域
  PREFIX: process.env.API_ENV === void 0 ? getPrefixByLocation() : process.env.API_ENV,
  // 是否正式环境（代码是否压缩）
  isRelease: NODE_ENV === 'production',
  // geekyum.com
  DOMAIN: getHostByLocation(),
  BASE_URL: null
}

// 获取域名
function getHostName(){
  const hostName = window.location.hostname;
  if(hostName.includes('admin.geekyum')){
    return 'larktimes.geekyum.com'
  }
  const locationHost = hostName.split('-');
  const prefix = locationHost[0];
  if(ENV_LIST.indexOf(prefix) > -1){
    return locationHost[1]
  } else {
    return hostName;
  }
}

function setBaseUrl() {
  // 如果有前缀，需要加[-]
  const PREFIX_DOT = params.PREFIX ? params.PREFIX + '-' : '';
  // geekyum.com
  const DOMAIN_URL = params.DOMAIN;
  // 首页地址
  const HOST_URL = `https://${PREFIX_DOT}${DOMAIN_URL}`;
  // 后端大羽
  const hostname = getHostName();
  const HOST_WORK_URL = `https://${PREFIX_DOT}${hostname}`;
  // 网关前缀
  var WG_PREFIX = 'gateway';
  // 登录前缀
  var PASSPORT_PREFIX = 'passport';
  // rate
  var RATE_PREFIX = 'rate';
  // 中台前缀域名
  var GIGA_PREFIX = 'giga';
  // 销售端前缀
  var SALES_PREFIX = 'gigasales';
  // 全球捷运单独逻辑
  if(window.location.hostname.includes('.worldex.com.cn')){
    WG_PREFIX = 'gatewayrate'
    PASSPORT_PREFIX = 'passportrate'
    GIGA_PREFIX = 'mgtrate';
    SALES_PREFIX = 'rate';
  } else if (window.location.hostname.includes('.loxson.com')) {
    // 亚东单独逻辑
    WG_PREFIX = 'ggate'
    PASSPORT_PREFIX = 'gpass'
    GIGA_PREFIX = 'gadmin'
    SALES_PREFIX = 'giga'
    RATE_PREFIX= 'grate'
  } else if (window.location.hostname.includes('.shippingchina.com')){
    // wiffa
    PASSPORT_PREFIX = 'login'
  } else if (window.location.hostname.includes('.casia.com')) {
    // 千亚单独逻辑
    WG_PREFIX = 'gateway.price'
    PASSPORT_PREFIX = 'passport.price'
    GIGA_PREFIX = 'manager.price'
    SALES_PREFIX = 'price'
  }

  // 全局URL
  params.BASE_URL = {
      // 通用api解析标志
      API_ORIGIN: '/api',
      // 通用数据api
      // http://geekyum.com/api/common
      API_COMMON: `${HOST_URL}/api/common`,
      // 网关地址
      // http://gateway.geekyum.com
      WG: `https://${PREFIX_DOT}${WG_PREFIX}.${DOMAIN_URL}`,
      // SSO地址
      // http://passport.geekyum.com
      YLD_PASSPORT: `https://${PREFIX_DOT}${PASSPORT_PREFIX}.${DOMAIN_URL}/login`,
      // 主页地址
      // http://www.geekyum.com
      HOME: HOST_URL,
      // 后端主页地址 https://demo.geekyum.com
      HOME_WORK: HOST_WORK_URL,
      // 前缀
      PREFIX_DOT: `${PREFIX_DOT}`,
      // geekyum.com
      DOMAIN_URL: `${DOMAIN_URL}`,
      // admin
      ADMIN_URL:`https://${PREFIX_DOT}admin.${DOMAIN_URL}`,
      // spot -- 去掉
      SPOT_URL:`https://${PREFIX_DOT}spot.${DOMAIN_URL}`,
      // rate
      RATE_URL:`https://${PREFIX_DOT}${RATE_PREFIX}.${DOMAIN_URL}`,
      // tracking
      TRACKING_URL:`https://${PREFIX_DOT}tracking.${DOMAIN_URL}`,
      // portal
      PORTAL_URL:`https://${PREFIX_DOT}portal.${DOMAIN_URL}`,
      // 中台管理端
      GIGA_URL:`https://${PREFIX_DOT}${GIGA_PREFIX}.${DOMAIN_URL}`,
      // 销售端
      GIGASALES_URL:`https://${PREFIX_DOT}${SALES_PREFIX}.${DOMAIN_URL}`
  };
}

function init() {
  if (params.BASE_URL) {
    return;
  }
  setBaseUrl();
}

init();

export default params;
export const ENV = NODE_ENV;
export const isLocal = params.isLocal;
export const PREFIX = params.PREFIX;
export const isRelease = params.isRelease;
export const DOMAIN = params.DOMAIN;
export const BASE_URL = params.BASE_URL;